import script from "./Fase3Verificacion.vue?vue&type=script&setup=true&lang=ts"
export * from "./Fase3Verificacion.vue?vue&type=script&setup=true&lang=ts"

import "./Fase3Verificacion.vue?vue&type=style&index=0&id=30b36515&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b36515"]])

export default __exports__